import React, { memo } from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from "@emotion/styled"
import GetWindowWidth from "../shared/GetWindowWidth"
import Img from "gatsby-image"
import ButtonLink from "../shared/ButtonLink"
import { breakpoints, color } from "../../utils/style"

const PromoWrapper = styled("div")`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 30px 0;
  .col-left {
    flex-basis: 78%;
    .gatsby-image-wrapper {
      border-radius: 8px;
    }
  }
  .col-right {
    flex-basis: 18%;
    .button {
      margin-bottom: 8px;
      width: 100%;
      padding: 10px 23px;
      border-width: 4px;
      filter: drop-shadow(0px 0px 48px rgba(196, 129, 0, 0.8));
    }
  }
  .qr-wrap {
    margin-bottom: 8px;
  }
  @media (max-width: ${breakpoints.md}) {
    .col-left {
      flex-basis: 68%;
    }
    .col-right {
      flex-basis: 30%;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .col-left {
      flex-basis: 100%;
      padding-bottom: 20px;
    }
    .col-right {
      flex-basis: 100%;
    }
  }
`

const PromoBlock = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          allWordpressPage(filter: { slug: { eq: "home-page" } }) {
            edges {
              node {
                acf {
                  promo_banner {
                    alt_text
                    title
                    path
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 860) {
                          ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                      }
                    }
                  }
                  promo_banner_mobile {
                    alt_text
                    title
                    path
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 600) {
                          ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                      }
                    }
                  }
                  promo_qr_code {
                    alt_text
                    title
                    path
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 260) {
                          ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const windowWidth = GetWindowWidth()
        const isDesktop = windowWidth > 600
        const homePageNode = data.allWordpressPage.edges[0].node
        const promoBanner = homePageNode?.acf?.promo_banner
        const promoBannerMobile = homePageNode?.acf?.promo_banner_mobile
        const promoQrCode = homePageNode?.acf?.promo_qr_code

        return (
          <PromoWrapper>
            <div className="col-left">
              {isDesktop ? (
                <div className="img-wrap">
                  {promoBanner &&
                    promoBanner?.localFile &&
                    promoBanner?.localFile?.childImageSharp && (
                      <Img
                        fluid={promoBanner.localFile.childImageSharp.fluid}
                        alt={
                          promoBanner.alt_text
                            ? promoBanner.alt_text
                            : "royal-1688.net"
                        }
                        fadeIn={false}
                        loading="eager"
                      />
                    )}
                </div>
              ) : (
                <div className="img-wrap">
                  {promoBannerMobile &&
                    promoBannerMobile?.localFile &&
                    promoBannerMobile?.localFile?.childImageSharp && (
                      <Img
                        fluid={
                          promoBannerMobile.localFile.childImageSharp.fluid
                        }
                        alt={
                          promoBannerMobile.alt_text
                            ? promoBannerMobile.alt_text
                            : "royal-1688.net"
                        }
                        fadeIn={false}
                        loading="eager"
                      />
                    )}
                </div>
              )}
            </div>
            <div className="col-right">
              <div className="qr-wrap">
                {promoQrCode &&
                  promoQrCode?.localFile &&
                  promoQrCode?.localFile?.childImageSharp && (
                    <Img
                      fluid={promoQrCode.localFile.childImageSharp.fluid}
                      alt={
                        promoQrCode.alt_text
                          ? promoQrCode.alt_text
                          : "royal-1688.net"
                      }
                      fadeIn={false}
                      loading="eager"
                    />
                  )}
              </div>
              <div>
                <ButtonLink
                  to={`tel:${process.env.PHONE_TO_CALL}`}
                  external={true}
                  ariaText="Call"
                  className="button transparent-button-gold"
                  text={process.env.PHONE_TO_DISPLAY}
                  iconName="call-answer"
                  iconColor={color.white}
                  iconLeft={true}
                  iconSize={18}
                />
              </div>
              <div>
                <ButtonLink
                  to={process.env.LINE_ID}
                  external={true}
                  iconColor={color.white}
                  ariaText="Line"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button transparent-button-gold"
                  text={process.env.LINE_ID_TEXT}
                  iconName="line"
                  iconLeft={true}
                  iconSize={18}
                />
              </div>
            </div>
          </PromoWrapper>
        )
      }}
    />
  )
}

export default memo(PromoBlock)
